import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createOrder } from "../../../Redux/Customers/Order/Action";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress"; // Import a loader
import { Loader } from "../../../components/Loader";

export default function AddDeliveryAddressForm({ handleNext }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { auth } = useSelector((store) => store);
  const [selectedAddress, setSelectedAdress] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true); // Set loading to true when starting the submission

    const data = new FormData(event.currentTarget);

    const address = {
      firstName: data.get("firstName"),
      lastName: data.get("lastName"),
      streetAddress: data.get("address"),
      city: data.get("city"),
      state: data.get("state"),
      zipCode: data.get("zip"),
      mobile: data.get("phoneNumber"),
    };

    dispatch(createOrder({ address, jwt, navigate }))
      .finally(() => {
        setLoading(false); // Reset loading state when submission is complete
        handleNext();
      });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Loader displayed while submitting */}
      {loading && (
        <Loader />
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="form-group">
          <label className="block text-white" htmlFor="firstName">First Name</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            className="w-full bg-gray-800 text-white border border-gray-600 p-2 rounded"
            required
          />
        </div>
        <div className="form-group">
          <label className="block text-white" htmlFor="lastName">Last Name</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            className="w-full bg-gray-800 text-white border border-gray-600 p-2 rounded"
            required
          />
        </div>
      </div>
      <div className="form-group">
        <label className="block text-white" htmlFor="address">Address</label>
        <textarea
          id="address"
          name="address"
          className="w-full bg-gray-800 text-white border border-gray-600 p-2 rounded"
          rows={4}
          required
        ></textarea>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="form-group">
          <label className="block text-white" htmlFor="city">City</label>
          <input
            type="text"
            id="city"
            name="city"
            className="w-full bg-gray-800 text-white border border-gray-600 p-2 rounded"
            required
          />
        </div>
        <div className="form-group">
          <label className="block text-white" htmlFor="state">State/Province/Region</label>
          <input
            type="text"
            id="state"
            name="state"
            className="w-full bg-gray-800 text-white border border-gray-600 p-2 rounded"
            required
          />
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="form-group">
          <label className="block text-white" htmlFor="zip">Zip / Postal Code</label>
          <input
            type="text"
            id="zip"
            name="zip"
            className="w-full bg-gray-800 text-white border border-gray-600 p-2 rounded"
            required
          />
        </div>
        <div className="form-group">
          <label className="block text-white" htmlFor="phoneNumber">Phone Number</label>
          <input
            type="text"
            id="phoneNumber"
            name="phoneNumber"
            className="w-full bg-gray-800 text-white border border-gray-600 p-2 rounded"
            required
          />
        </div>
      </div>
      <button
        type="submit"
        className="w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700 transition"
        disabled={loading} // Disable button while loading
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Deliver Here"}
      </button>
    </form>
  );
}
